import { api } from "@/lib/api";
import { ago, longDate } from "@/lib/sk";

export const brukereApi = {
  status: () => api.get("/brukere/status"),
  list: () => api.get("/admin/users"),
  create: (body) => api.post("/admin/users", body),
  update: (id, body) => api.patch(`/admin/users/${id}`, body),
  resetPassword: (id) => api.post(`/admin/users/${id}/reset-password`),
  deactivate: (id) => api.post(`/admin/users/${id}/deactivate`),
  activate: (id) => api.post(`/admin/users/${id}/activate`),
  history: (id) => api.get(`/admin/users/${id}/history`),
  avatar: (id, file) => { const fd = new FormData(); fd.append("file", file, file.name || "profilbilde.jpg"); return api.post(`/admin/users/${id}/avatar`, fd, { headers: { "Content-Type": "multipart/form-data" } }); },
  removeAvatar: (id) => api.delete(`/admin/users/${id}/avatar`),
};

export const ROLE_LABEL = { Sales: "Salg", Engineering: "Ingeniør", "Sales manager": "Salgssjef", Management: "Ledelse" };

export const firstName = (name) => (name || "").trim().split(/\s+/)[0] || "";

/** The one state worth a word. Normal (active, signed in, own password) has none. */
export function userState(u) {
  if (!u) return null;
  if (!u.is_active) return { key: "inactive", label: "Deaktivert", tone: "muted" };
  if (u.locked_until) return { key: "locked", label: "Midlertidig sperret", tone: "bad" };
  if (u.must_change_password && !u.last_login_at) return { key: "invited", label: "Venter på første innlogging", tone: "warn" };
  if (u.must_change_password) return { key: "reset", label: "Må velge nytt passord", tone: "warn" };
  return null;
}

export function lastSeen(u) {
  if (!u) return "";
  if (!u.is_active) return u.deactivated_at ? `Deaktivert ${longDate(u.deactivated_at)}` : "Deaktivert";
  if (!u.last_login_at) return u.created_at ? `Opprettet ${ago(u.created_at)}` : "Aldri logget inn";
  return `Sist innlogget ${ago(u.last_login_at)}`;
}

export const ACTION_LABEL = {
  created: "Bruker opprettet",
  promoted: "Fikk innlogging",
  updated: "Profil endret",
  flag_granted: "Rettighet gitt",
  flag_revoked: "Rettighet fjernet",
  password_reset: "Nytt midlertidig passord",
  password_changed: "Valgte eget passord",
  deactivated: "Deaktivert",
  activated: "Aktivert igjen",
  avatar_set: "Profilbilde lagt inn",
  avatar_removed: "Profilbilde fjernet",
};

export function credentialsMessage({ name, email, password }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return [
    `Hei ${firstName(name)}!`,
    "",
    "Du har fått tilgang til LOS Marine Workspace.",
    "",
    `Logg inn: ${origin}/login`,
    `E-post: ${email}`,
    `Midlertidig passord: ${password}`,
    "",
    "Du blir bedt om å velge ditt eget passord første gang du logger inn.",
  ].join("\n");
}

export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) { /* fall through to the textarea fallback */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}
